export default __webpack_public_path__ + "static/googlecloud-92f0d87f01c3e4fdd513f3056f706e10.svg";